import { connect } from 'react-redux';
import EnhancementButton from '../enhancementButton/enhancementButton';
import { openPanel, closePanelByType } from '../../../../shared/actions/sidebar';
import { panelGroup, panelType } from '../../../../shared/constants';
import { isPanelOpen, shouldRestoreOpenerFocus } from '../../../../shared/actions/sidebarUtils';

const mapStateToProps = state => ({
  active: state.sidebar.isOpen && isPanelOpen(state, panelGroup.enhancements, panelType.outline),
  canShow: !!(state.outline && state.outline.length),
  heading: 'Outline',
  attributeId: 'outline',
  restoreFocus: shouldRestoreOpenerFocus(state, panelGroup.enhancements, panelType.outline),
});

const mapDispatchToProps = dispatch => ({
  closeSidePanel: () => dispatch(closePanelByType(panelGroup.enhancements, panelType.outline)),
  openSidePanel: () => dispatch(openPanel(panelGroup.enhancements, panelType.outline)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EnhancementButton);
